<template>
  <q-dialog
    :visible="isVisible"
    :title="`${salesVolumeName}情况`"
    width="40%"
    :innerScroll="false"
    :showFooter="false"
    @close="onClose"
  >
    <el-table
      :data="salesVolumeData"
      v-loading="loading"
      border
      :height="300"
      element-loading-text="数据加载中"
      element-loading-spinner="el-icon-loading"
      :header-cell-style="{
        backgroundColor: '#FAFAFA',
      }"
      style="width: 100%"
    >
      <el-table-column
        prop="storeName"
        label="店铺"
        :show-overflow-tooltip="true"
        align="left"
      ></el-table-column>
      <el-table-column
        prop="sales"
        :label="salesVolumeName"
        :show-overflow-tooltip="true"
        align="right"
      >
        <template slot-scope="scope">
          {{ Number(scope.row.sales).toLocaleString() }}
        </template>
      </el-table-column>
    </el-table>
  </q-dialog>
</template>

<script>
export default {
  name: 'SalesVolumeDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    scope: {
      type: Object,
      default: () => ({})
    },
    searchForm: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    isVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  data() {
    return {
      loading: false,
      salesVolumeData: [],
      salesVolumeName: '销量'
    }
  },
  watch: {
    visible(val) {
      if (val && this.scope && this.scope.row) {
        this.fetchData()
      }
    }
  },
  methods: {
    onClose() {
      this.isVisible = false
    },
    fetchData() {
      let type = this.scope.column.label.includes('销售额') ? 1 : 0
      this.salesVolumeName = type == 1 ? '销售额' : '销量'
      let payMonth = this.scope.column.property
      let data = {
        bigModel: this.scope.row.bigModel,
        category: this.scope.row.categoryName,
        payMonth: this.scope.column.property.slice(
          payMonth.length - 6,
          payMonth.length
        ),
        saleLocation: this.scope.row.thisMonthSale,
        storeCode: this.searchForm.storeCode,
        type: type,
      }
      this.loading = true
      this.$q.productModelDetails
        .bigModelSalesSituation({ data: data })
        .then((res) => {
          if (res.code === '200') {
            this.salesVolumeData = res.data
          } else {
            this.$message.error(res.message)
          }
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="stylus" scoped>
</style>
